import { useStoryblokApi } from "@storyblok/react";
import { use, Suspense, useMemo } from "react";
import { Link } from "react-router";
import "./articleoverview.css";
import { getEnvironmentVersion } from "../../../utils/getEnvironmentVersion";

export default function ArticleOverview({blok}) {
  const storyblokApi = useStoryblokApi();
  const articlesPromise = useMemo(() => {
    return storyblokApi.getAll("cdn/stories", {
      version: getEnvironmentVersion(),
      starts_with: "case-studies",
      content_type: "article",
    });
  }, [storyblokApi]);
 
  return (
    <section>
      <div className="container herosub">

                  <h1>{blok.Title}</h1>
                  <h2>{blok.Subheading}</h2>
      </div>

      <Suspense
        fallback={
          <div className="center">
            <span className="cat-loader"></span>
          </div>
        }
      >
        <div className="case-study-list-wrapper">
          <ul className="case-study-list">
            <ArticleList getArticles={articlesPromise} />
          </ul>
        </div>
      </Suspense>
    </section>
  );
}

export function ArticleList({ getArticles }) {
  const articles = use(getArticles);

  return articles.map((article) => (
    <li
      key={article.uuid}
      className="case-study-single"
      // style={{ backgroundImage: `url(${article.content.largeimage.filename})` }}
    >
      <div className="article-meta">
        <div className="image-wrap">
          <img src={article.content.largeimage.filename} />
        </div>
        <div className="data-wrap">
          <h4>{article.name}</h4>

          <p>{article.content.subtitle}</p>
          <Link to={`/${article.full_slug}`} className="articlelink">
            {/* {article.name} */}Read case study
          </Link>
        </div>
      </div>
    </li>
  ));
}
